module.exports = __webpack_public_path__ + "static/media/Cooperationbg.43546a53.png";